/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Custom_Max_CharsInputs */

const en_live_caption_custom_max_chars = /** @type {(inputs: Live_Caption_Custom_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom`)
};

const fr_live_caption_custom_max_chars = /** @type {(inputs: Live_Caption_Custom_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coutume`)
};

const de_live_caption_custom_max_chars = /** @type {(inputs: Live_Caption_Custom_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brauch`)
};

const it_live_caption_custom_max_chars = /** @type {(inputs: Live_Caption_Custom_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costume`)
};

const ru_live_caption_custom_max_chars = /** @type {(inputs: Live_Caption_Custom_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обычай`)
};

const es_live_caption_custom_max_chars = /** @type {(inputs: Live_Caption_Custom_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costumbre`)
};

const zh_cn2_live_caption_custom_max_chars = /** @type {(inputs: Live_Caption_Custom_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`风俗`)
};

const ja_live_caption_custom_max_chars = /** @type {(inputs: Live_Caption_Custom_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタム`)
};

const hi_live_caption_custom_max_chars = /** @type {(inputs: Live_Caption_Custom_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिवाज़`)
};

const pt_pt2_live_caption_custom_max_chars = /** @type {(inputs: Live_Caption_Custom_Max_CharsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizado`)
};

/**
* | output |
* | --- |
* | "Custom" |
*
* @param {Live_Caption_Custom_Max_CharsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_custom_max_chars = /** @type {((inputs?: Live_Caption_Custom_Max_CharsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Custom_Max_CharsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_custom_max_chars(inputs)
	if (locale === "de") return de_live_caption_custom_max_chars(inputs)
	if (locale === "it") return it_live_caption_custom_max_chars(inputs)
	if (locale === "ru") return ru_live_caption_custom_max_chars(inputs)
	if (locale === "es") return es_live_caption_custom_max_chars(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_custom_max_chars(inputs)
	if (locale === "ja") return ja_live_caption_custom_max_chars(inputs)
	if (locale === "hi") return hi_live_caption_custom_max_chars(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_custom_max_chars(inputs)
	return en_live_caption_custom_max_chars(inputs)
});